import DeleteIcon from "@mui/icons-material/Delete";
import {
  Autocomplete,
  AccordionDetails as Box,
  Button,
  TextField,
  Tooltip,
} from "@mui/material";
import { Dispatch, SetStateAction, useState } from "react";
import { Magasin } from "../../../models/Magasin";
import { RequestToSend } from "../../../models/RequestToSend";
import { addRequestToSend } from "../../../redux/features/appStateSlice";
import {
  planoAPI
} from "../../../redux/features/cache";
import { useAppDispatch } from "../../../redux/store";

export interface SelectionFormProps {
  plansSeq: number | undefined;
  setOpen: Dispatch<SetStateAction<boolean>>;
  canDelete: boolean;
}

export const MagasinForm = (props: SelectionFormProps) => {
  const dispatch = useAppDispatch();

  const [addSecMagasin] = planoAPI.endpoints.addSecMagasin.useMutation();
  const { data: magasins = [] as Magasin[] } = planoAPI.endpoints.getMagasins.useQuery({
    banniere: "",
    treeView: false,
  });

  const [storeNumber, setStoreNumber] = useState<number>(-1);
  const [targetQuantity, setTargetQuantity] = useState<number>(0);

  const handleSubmit = () => {
    dispatch(
      addRequestToSend(
        new RequestToSend(
          `Ajout section magasin ${storeNumber}`,
          addSecMagasin,
          () => props.setOpen(false),
          {},
          {
            plans_seq: props.plansSeq,
            mag_num: storeNumber,
            nombre_vise: targetQuantity,
          },
          []
        )
      )
    );
  };

  return (
    <Box sx={{ display: "flex", p: 0 }}>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          p: 0,
        }}
      >
        <Autocomplete
          options={magasins}
          clearOnBlur={false}
          getOptionLabel={(cat) => `${cat.mag_nom}`}
          onChange={(e, data) => setStoreNumber(data!.mag_num)}
          onInputChange={(event) => {
            event?.stopPropagation();
          }}
          sx={{ width: "33%", m: 1 }}
          renderInput={(params) => (
            <TextField
              sx={{
                color: "red",
              }}
              {...params}
              label="Magasin"
            />
          )}
        />
        <TextField
          label="Objectif produit sur plancher"
          sx={{ width: "33%", m: 1 }}
          type="number"
          onChange={(e) => setTargetQuantity(parseInt(e.target.value))}
        />

        <TextField
          label="Qté actuelle sur plancher"
          sx={{ width: "33%", m: 1 }}
          disabled
        />
      </Box>

      <span
        style={{
          display: "flex",
          alignItems: "center",
          padding: "6px 28px",
          cursor: "pointer",
        }}
        className={`save-wrapper`}
      >
        <span
          className={`k-icon k-font-icon k-i-save k-icon-xl`}
          onClick={handleSubmit}
        ></span>
      </span>
      <Tooltip title="Annuler">
        <span style={{ display: "flex" }}>
          <Button
            disabled={!props.canDelete}
            onClick={() => props.setOpen(false)}
            color="error"
          >
            <DeleteIcon />{" "}
          </Button>
        </span>
      </Tooltip>
    </Box>
  );
}
